<template>
	<div>
		<div :style="borderStyle" class="logo-uploader-circle-wrapper mb-35">
			<label
				v-loading="loading"
				:style="logoStyle"
				class="logo-uploader-circle"
				for="logo-upload"
			>
				<template v-if="!logoStyle">
					<div class="h3 font-uppercase">{{ $tc('components.logoUploader.title') }}</div>
					<div class="mt-10 link">{{ $tc('components.logoUploader.buttonText') }}</div>
				</template>
				<input
					v-show="false"
					id="logo-upload"
					ref="logoInput"
					accept="image/*"
					name="logo-upload"
					type="file"
					@change="triggerUpload"
				>
			</label>
		</div>
	</div>
</template>

<script>
import { fileToBase64 } from '~/assets/util/helpers'

export default {
	name: 'LogoUploader',
	props: {
		logo: {
			type: String,
			required: true
		},
		color: {
			type: String,
			required: true
		}
	},
	data () {
		return {
			loading: false,
			uploadedLogo: ''
		}
	},

	computed: {
		logoStyle () {
			const src = this.uploadedLogo || this.logo

			return src ? { backgroundImage: `url(${src})` } : null
		},
		borderStyle () {
			if (this.color) {
				const styles = { backgroundColor: this.color }

				if (this.color === '#FFFFFF') {
					styles.borderColor = '#c4c4c4'
				}

				return styles
			}

			return null
		}
	},
	methods: {
		async uploadTempFile (file) {
			const params = { contentType: file.type }
			const getTempUploadFileUrl = (params) => {
				const query = new URLSearchParams(params).toString()

				return this.$axios.$get(`/api/v1/files/signedUrl/temporary?${query}`)
			}
			const uploadFileToUrl = (url, file, type) => {
				return this.$axios.put(url, file, { headers: { 'content-type': type }, skipAuth: true })
			}

			const tempResponse = await getTempUploadFileUrl(params)
			const { url, fileKey } = tempResponse.data

			await uploadFileToUrl(url, file, file.type)

			return fileKey
		},

		async triggerUpload (event) {
			const logo = event.target.files[0]

			if (logo) {
				this.loading = true

				try {
					const fileKey = await this.uploadTempFile(logo)

					this.uploadedLogo = await fileToBase64(logo)

					this.$emit('update:logo', fileKey)
				} catch (error) {
					this.$toast.error(this.$tc('errors.logoUploadError'))
				}

				this.$refs.logoInput.value = null
				this.loading = false
			}
		}
	}
}
</script>

<style lang="scss">
	.logo-uploader-circle-wrapper {
		display: flex;
		justify-content: center;
		align-items: center;
		width: 240px;
		height: 240px;
		border-radius: 50%;
		border: 1px solid $white;
		transition: 0.3s background-color;

		.logo-uploader-circle {
			cursor: pointer;
			overflow: hidden;

			width: 210px;
			height: 210px;
			padding: 20px;
			border-radius: 50%;
			background-color: $content-bg;
			background-size: cover;
			background-repeat: no-repeat;
			background-position: center center;

			display: flex;
			text-align: center;
			align-items: center;
			flex-direction: column;
			justify-content: center;

			.h3 {
				color: #939393;
				font-weight: bold;
				text-align: center;
			}

			@include respond-below(laptop) {
				margin: 0 auto;
			}
		}
	}
</style>
